@if (loading) {
    <div class="w-full h-full flex bg-gray18 items-center justify-center">
        <app-loader size="medium" />
    </div>
} @else {
    <header>
        <app-branding-bar />
        @if (navbarVisible) {
            <app-tenant-selection />
        }
        <ng-container *ngTemplateOutlet="navbar" />
    </header>
    <router-outlet />
}
<ng-template #menuTemplateRef> WF Menu </ng-template>
<ng-template #navbar>
    @if (navbarVisible) {
        <app-navbar
            [navItems]="isErrorPage ? [] : navItems"
            [activeNavItem]="activeNavItemId">
            <ng-template #menuTemplate>
                <button
                    mat-icon-button
                    aria-label="User"
                    class="mr-2"
                    [attr.data-qa]="dataQa.userMenuTriggerButton"
                    [matMenuTriggerFor]="userMenu">
                    <mat-icon class="color-gray16" svgIcon="user" />
                </button>
                <mat-menu #userMenu="matMenu">
                    <div wfeStopClick [style.width]="'180px'">
                        <div class="user pl-4 pt-2 pr-2 color-gray13">
                            <div>{{ user.name }}</div>
                            <div class="text-xs color-orange6">
                                {{ user.role }}
                            </div>
                        </div>
                        <button
                            mat-menu-item
                            [attr.data-qa]="dataQa.userMenuLogoutButton"
                            (click)="logout()">
                            Logout
                        </button>
                    </div>
                </mat-menu>
            </ng-template>
        </app-navbar>
    }
</ng-template>
